var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition,@typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "@mui/material/Button";
import { useQuery } from "../../hooks";
import { Container } from "../../components/atoms/Container";
import { EButtonTypes } from "../../types";
import * as api from "../../api";
import { Alerts } from "../../components/molecules/Alerts/Alerts";
import { TableHead } from "../../components/atoms/Table/TableHead";
import { TableBodyWithScroll } from "../../components/atoms/Table/TableBodyWithScroll";
import { TableHeaderCell } from "../../components/atoms/Table/TableHeaderCell";
import { TableBodyCell } from "../../components/atoms/Table/TableBodyCell";
import { Table } from "../../components/atoms/Table";
import { UnderLine } from "../../components/atoms/UnderLine";
import { Delimiter } from "../../components/atoms/Delimiter";
import { PageWrapper } from "../../components/atoms/PageWrapper";
import { useErrorHandler } from "../../hooks/useErrorHandler";
import { TableRow } from "@mui/material";
const FormContainer = styled.div `
  width: 100%;
  //height: 180px;
  //padding: 15px 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const InputsWrapper = styled.div `
  display: flex;
  //justify-content: space-between;
`;
const InputContainer = styled.div `
  position: relative;
  display: flex;
  margin-right: 50px;
`;
const Input = styled(Field) `
  //box-sizing: border-box;
  width: 200px;
  height: 32px;
  padding: 0 10px;
`;
const Wrapper = styled.div `
  //padding: 50px 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const Title = styled.div `
  margin-bottom: 10px;
  padding: 10px 0;
  font-size: 3rem;
`;
const TableCellNumberHeader = styled(TableHeaderCell) `
  width: 78px;
`;
const TableCellNameHeader = styled(TableHeaderCell) `
  width: 87px;
`;
const TableCellNickHeader = styled(TableHeaderCell) `
  width: 211px;
`;
const TableCellGamesHeader = styled(TableHeaderCell) `
  width: 88px;
`;
const TableCellPayHeader = styled(TableHeaderCell) `
  width: 157px;
`;
const TableBodyRow = styled.tr `
  cursor: pointer;
  &:hover {
    background: lightgray;
  }
`;
const TableCellNumberBody = styled(TableBodyCell) `
  width: 78px;
`;
const TableCellNameBody = styled(TableBodyCell) `
  width: 87px;
`;
const TableCellNickBody = styled(TableBodyCell) `
  width: 211px;
`;
const TableCellGamesBody = styled(TableBodyCell) `
  width: 88px;
`;
const TableCellPayBody = styled(TableBodyCell) `
  width: 146px;
`;
const Error = styled.span `
  color: red;
  position: absolute;
  top: 110%;
  z-index: 100;
`;
const TableContainer = styled.div `
  //overflow-y: scroll;
  //-webkit-overflow-scrolling: touch;
  width: 100%;
`;
const requiredFieldError = "Это поле необходимо заполнить";
const validationCreateSchema = Yup.object().shape({
    realName: Yup.string().required(requiredFieldError),
    gameName: Yup.string().required(requiredFieldError),
});
const renderError = (message) => _jsx(Error, { children: message });
export const AddPlayersToMatch = () => {
    const { param: matchId } = useQuery("matchId");
    const [players, setPlayers] = useState([]);
    const nav = useNavigate();
    const { errorHandler, setSuccess } = useErrorHandler();
    const initialSearchValues = {
        real_name: "",
        game_name: "",
        matchId: matchId || "",
        socials: "",
    };
    const searchPlayer = (data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield api.searchPlayers(data);
            // console.log('AddPlayersToMatch searchPlayers', result)
            setPlayers(result);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log("AddPlayersToMatch searchPlayers error", e);
            errorHandler(e);
        }
    });
    useEffect(() => {
        searchPlayer(initialSearchValues);
    }, []);
    const onSearchSubmit = (data) => {
        // console.log('AddPlayersToMatch', data)
        searchPlayer(data);
    };
    const addPlayer = (playerId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // console.log('AddPlayersToMatch addPlayer', playerId, matchId)
            yield api.addPlayerToMatch({ playerId, matchId: matchId || "" });
            setSuccess("Игрок успешно добавлен в игру");
            // nav(-1)
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error("AddPlayersToMatch addPlayer error", e.response);
            errorHandler(e);
        }
    });
    const backToMatch = () => {
        nav(`/match-config?matchId=${matchId}`);
    };
    return (_jsxs(Container, { children: [_jsx(Alerts, {}), _jsxs(PageWrapper, { children: [_jsx(Button, Object.assign({ onClick: backToMatch }, { children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0438\u0433\u0440\u0435" })), _jsx(Formik, Object.assign({ initialValues: initialSearchValues, onSubmit: onSearchSubmit }, { children: _jsx(Form, { children: _jsxs(FormContainer, { children: [_jsxs(InputsWrapper, { children: [_jsx(InputContainer, { children: _jsx(Input, { name: "real_name", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F", type: "text" }) }), _jsx(InputContainer, { children: _jsx(Input, { name: "game_name", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u041D\u0438\u043A", type: "text" }) })] }), _jsx(Delimiter, { top: "20px" }), _jsx(Button, Object.assign({ type: EButtonTypes.SUBMIT, sx: { width: "200px" } }, { children: "\u041D\u0430\u0439\u0442\u0438" }))] }) }) })), _jsx(Delimiter, { top: "30px" }), _jsx(Title, { children: "\u041D\u0430\u0439\u0434\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u043E\u043A\u0438" }), _jsx(TableContainer, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCellNumberHeader, { children: "\u041D\u043E\u043C\u0435\u0440" }), _jsx(TableCellNameHeader, { children: "\u0418\u043C\u044F" }), _jsx(TableCellNickHeader, { children: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u041D\u0438\u043A" }), _jsx(TableCellGamesHeader, { children: "\u041A\u043E\u043B-\u0432\u043E \u0438\u0433\u0440" }), _jsx(TableCellPayHeader, {})] }) }), _jsx(TableBodyWithScroll, { children: players === null || players === void 0 ? void 0 : players.map((player, index) => (_jsxs(TableBodyRow, { children: [_jsx(TableCellNumberBody, { children: index + 1 }), _jsx(TableCellNameBody, { children: player.realName }), _jsx(TableCellNickBody, { children: player.gameName }), _jsx(TableCellGamesBody, { children: player.gamesCount }), _jsx(TableCellPayBody, { children: _jsx(Button, Object.assign({ onClick: () => addPlayer(player.id), sx: { width: "100px", fontSize: "1.2rem" } }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" })) })] }, player.id))) })] }) }), _jsx(UnderLine, {})] })] }));
};
